import { useMemo } from 'react'
import { Country, Department, User } from '@core/app/types/contactsApiType'

interface ProcessedData {
    [key: string]: {
        name: string;
        flag: string | null;
        departments: { [key: number]: Department };
    };
}

const useProcessedData = (data: Country[] | undefined): ProcessedData | undefined => {
    return useMemo(() => {
        if (!data) {
            return undefined;
        }

        const dataMap: ProcessedData = {};

        data.forEach(country => {
            const key = `${country.countryId}-${country.country}`;
            // Initialize the country entry if it doesn't exist in the data map
            if (!dataMap[key]) {
                dataMap[key] = {
                    name: country.country,
                    flag: country.flag,
                    departments: {}
                };
            }

            // Process each department in the country
            country.departments.forEach(department => {
                // Initialize department if not already present
                if (!dataMap[key].departments[department.id]) {
                    dataMap[key].departments[department.id] = {
                        ...department,
                        users: []
                    };
                }

                // Append users to the department
                department.users.forEach(user => {
                    const newUser: User = {
                        ...user
                    };
                    dataMap[key].departments[department.id].users.push(newUser);
                });
            });
        });

        return dataMap;
    }, [data]);
};

export default useProcessedData;
